import React from 'react';
import { Typography } from 'antd';

import type { CategoryAdmin } from '../../../services/admin';

interface Props {
  /** Categorias da edição escolhida (`EdicaoAdmin.categoryIds`). */
  categoryIds: number[];
  /** Todas as categorias (`listCategoriesAdmin`), para resolver os nomes. */
  categories: CategoryAdmin[];
}

/** Linha somente leitura: o jogo herda as categorias da edição, não tem as suas. */
export const EdicaoCategoriesLine: React.FC<Props> = ({ categoryIds, categories }) => {
  const names = categoryIds
    .map((id) => categories.find((c) => c.id === id)?.name)
    .filter((name): name is string => Boolean(name));
  return (
    <Typography.Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
      {`Categorias: ${names.length > 0 ? names.join(', ') : 'nenhuma'} (vêm da edição)`}
    </Typography.Text>
  );
};
